var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"home--header-container"},[_vm._m(0),_c('div',{staticClass:"home--account-card"},[_c('account-card')],1)]),_c('set-manifest')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home--logo"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("../../assets/img/header-logo.png")}}),_vm._v(" Enroller")])])
}]

export { render, staticRenderFns }